export default "__VITE_ASSET__BbQWBlE1__"